"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PRIVACY_POLICY_URL = exports.TERMS_OF_USE_URL = exports.getSeatsPassengersDetailTextIcon = exports.getTimelineTextIcon = exports.onSaveAddAircraft = exports.editExistingLicense = exports.setLicenseButtonValidation = exports.setUserLanguage = exports.changeLanguage = exports.removeAccountButtonValidation = exports.loginButtonValidation = exports.signUpButtonValidation = exports.signUpPasswordValidation = exports.emailValidation = exports.fullNameValidation = exports.changePasswordButtonValidation = exports.resetPasswordButtonValidation = exports.passwordValidation = void 0;
// import moment from "moment/moment";
const react_datepicker_1 = require("react-datepicker");
const userHandlers_1 = require("../handlers/userHandlers");
const i18next_1 = __importDefault(require("i18next"));
const lodash_1 = require("lodash");
const pilotHandlers_1 = require("../handlers/pilotHandlers");
const dictionaries_1 = require("./dictionaries");
const utils_1 = require("./utils");
const aircraftHandlers_1 = require("../handlers/aircraftHandlers");
const images_1 = require("./images");
const config_1 = require("../config/config");
const passwordValidation = (value, comparativeValue = null) => {
    if (value.length < 10)
        return 'passwordShort';
    if (comparativeValue !== null && value !== comparativeValue)
        return 'passwordsNotEqual';
    return null;
};
exports.passwordValidation = passwordValidation;
const resetPasswordButtonValidation = (password) => {
    return ((0, exports.passwordValidation)(password.newPassword) === null &&
        (0, exports.passwordValidation)(password.repeatedPassword, password.newPassword) === null);
};
exports.resetPasswordButtonValidation = resetPasswordButtonValidation;
const changePasswordButtonValidation = (password) => {
    return ((0, exports.passwordValidation)(password.oldPassword) === null &&
        (0, exports.passwordValidation)(password.newPassword) === null &&
        (0, exports.passwordValidation)(password.repeatedPassword, password.newPassword) === null);
};
exports.changePasswordButtonValidation = changePasswordButtonValidation;
const fullNameValidation = (value) => {
    if (value.startsWith(" "))
        return 'whiteSpaceError';
    if (value.length < 3) {
        return 'fullNameError';
    }
    return null;
};
exports.fullNameValidation = fullNameValidation;
const emailValidation = (value) => {
    if (!(0, utils_1.validateEmail)(value))
        return 'emailError';
    return null;
};
exports.emailValidation = emailValidation;
const signUpPasswordValidation = (value) => {
    if (value.length < 10)
        return 'passwordError';
    return null;
};
exports.signUpPasswordValidation = signUpPasswordValidation;
const signUpButtonValidation = (data) => ((0, exports.emailValidation)(data.email) === null &&
    (0, exports.signUpPasswordValidation)(data.password) === null &&
    (0, exports.fullNameValidation)(data.fullName) === null);
exports.signUpButtonValidation = signUpButtonValidation;
const loginButtonValidation = (data) => (0, exports.emailValidation)(data.email) === null &&
    (0, exports.passwordValidation)(data.password) === null;
exports.loginButtonValidation = loginButtonValidation;
const removeAccountButtonValidation = (data) => (0, exports.passwordValidation)(data.password) === null;
exports.removeAccountButtonValidation = removeAccountButtonValidation;
const changeLanguage = (lng) => {
    // moment.locale(lng);
    (0, react_datepicker_1.setDefaultLocale)(lng);
    (0, userHandlers_1.editUserHandler)({ 'language': lng });
    i18next_1.default.changeLanguage(lng).then(() => { console.log('change'); });
};
exports.changeLanguage = changeLanguage;
const setUserLanguage = (lng) => {
    // moment.locale(lng);
    (0, react_datepicker_1.setDefaultLocale)(lng);
    i18next_1.default.changeLanguage(lng).then(() => { console.log('change'); });
};
exports.setUserLanguage = setUserLanguage;
const setLicenseButtonValidation = (localData, licenseData, userIsPilot) => {
    const isFilled = (0, lodash_1.every)(localData, field => {
        if ((0, lodash_1.isArray)(field)) {
            return !(0, lodash_1.isEmpty)(field);
        }
        return !!field;
    });
    if (userIsPilot) {
        return !(0, lodash_1.isEqual)(localData, licenseData) && isFilled;
    }
    return isFilled;
};
exports.setLicenseButtonValidation = setLicenseButtonValidation;
const editExistingLicense = (localData, licenseData) => {
    const keys = Object.keys(dictionaries_1.initialLicenseState);
    function isKey(x, k) { return k in x; }
    let changes = {};
    keys.forEach((key => {
        if (isKey(localData, key) && isKey(licenseData, key)) {
            if (!(0, lodash_1.isEqual)(localData[key], licenseData[key])) {
                changes[key] = localData[key];
            }
        }
    }));
    (0, pilotHandlers_1.editPilotLicenseHandler)(changes);
};
exports.editExistingLicense = editExistingLicense;
const onSaveAddAircraft = ({ setEditedAircraft, setData, setShowList, editedAircraft, data, isAircraftAdded, edited, userIsPilot }) => {
    if (userIsPilot) {
        if ((0, lodash_1.isNumber)(editedAircraft.id) && isAircraftAdded) {
            (0, aircraftHandlers_1.editAircraftHandler)(editedAircraft.id, editedAircraft);
        }
        else {
            (0, aircraftHandlers_1.addPilotAircraftHandler)(editedAircraft.id, editedAircraft, edited);
        }
    }
    else {
        isAircraftAdded ?
            setData(data.map(oldAircraft => oldAircraft.reg_number === editedAircraft.reg_number ? {
                ...editedAircraft,
                edited
            } : oldAircraft)) :
            setData([...data, { ...editedAircraft, edited }]);
    }
    setShowList(true);
    setEditedAircraft(dictionaries_1.initialAircraft);
};
exports.onSaveAddAircraft = onSaveAddAircraft;
const getTimelineTextIcon = (flightData, t) => {
    let text, icon;
    if (flightData.isCanceled) {
        text = t('details.canceled');
        icon = images_1.icons.Cancel;
    }
    else if (flightData.isCompleted) {
        text = `${t('details.completed')} (${flightData.flightTime})`;
        icon = images_1.icons.Completed;
    }
    else {
        text = flightData.flightTime;
        icon = images_1.icons.TimelineAirplane;
    }
    return { text, icon };
};
exports.getTimelineTextIcon = getTimelineTextIcon;
const getSeatsPassengersDetailTextIcon = (flightData, t) => {
    let text, icon;
    if (flightData.isOngoing) {
        text = `${flightData.available_seats} ${t(flightData.available_seats === 1 ? "overview.seat" : "overview.seats")}`;
        icon = images_1.icons.SeatsDetail;
    }
    else {
        text = `${flightData.passengersCount} ${t(flightData.passengersCount === 1 ? "overview.passenger" : "overview.passengers")}`;
        icon = images_1.icons.PassengerDetail;
    }
    return { text, icon };
};
exports.getSeatsPassengersDetailTextIcon = getSeatsPassengersDetailTextIcon;
exports.TERMS_OF_USE_URL = config_1.APP_URL + 'terms-of-use';
exports.PRIVACY_POLICY_URL = config_1.APP_URL + 'privacy-policy';
